import { render, staticRenderFns } from "./PaperAnswerResult.vue?vue&type=template&id=153213e7&scoped=true"
import script from "./PaperAnswerResult.vue?vue&type=script&lang=js"
export * from "./PaperAnswerResult.vue?vue&type=script&lang=js"
import style0 from "./PaperAnswerResult.vue?vue&type=style&index=0&id=153213e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153213e7",
  null
  
)

export default component.exports